<template>
  <div>
    <top-nav></top-nav>
    <div class="page_content">
      <div class="crumb">体育资讯 / 新闻详情</div>
      <p class="details_title">{{details.title}}</p>
      <p class="details_time">{{details.uploadTime}}</p>
      <p class="details_info" v-html="details.content"></p>

<!--      <div class="categoryBar">-->
<!--        <ul>-->
<!--          <li v-for="(item,index) in categoryList" :key="'category'+index">-->
<!--            <div class="category_div">-->
<!--              <img :src="require('@/assets/image/sportsInformation/'+item.url)"/>-->
<!--              <div class="div_right">-->
<!--                <div class="category_top">-->
<!--                  <p class="li_title text_overflow">{{ item.title }}</p>-->
<!--                  <p class="li_info">{{ item.info }}</p>-->
<!--                </div>-->
<!--                <p class="li_time">{{ item.time }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <p class="line_block" v-if="(index+1)%2 !==0"></p>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div class="pagination_con">-->
<!--          <el-pagination-->
<!--              :total="100"-->
<!--              background-->
<!--              layout="prev, pager, next">-->
<!--          </el-pagination>-->
<!--        </div>-->

<!--      </div>-->
    </div>

    <bot-nav></bot-nav>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import botNav from "@/components/botNav";
import {FILE_API} from "@/Settings";

export default {
  name: "sportsDetails",
  components: {
    topNav,
    // eslint-disable-next-line vue/no-unused-components
    botNav
  },
  data() {
    return {
      fileUrl:FILE_API,
      categoryList: [],
      details:{}
    }
  },
  created() {
    this.details=JSON.parse(this.$route.query.item)
  },
  methods:{

  }
}
</script>

<style scoped lang="less">
.page_content {
  padding: 19px 100px 0px 100px;

  p {
    margin: 0;
    padding: 0;
  }

  .details_title {
    font-size: 48px;
    color: #333;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .details_time {
    font-weight: 400;
    font-size: 24px;
    color: #999999;
    text-align: center;
    margin-bottom: 58px;
  }

  .details_info {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
  }

  .details_point {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    padding: 0 0 0 20px;
    text-align: left;
    text-justify: unset;
    line-height: 40px;
  }
}

.pic_con {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  img {
    height: 722px;
  }
}

.categoryBar {
  width: 100%;

  ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      width: calc(100% / 2);
      display: flex;
      cursor: pointer;

      .line_block {
        height: 100%;
        width: 1px;
        background-color: rgba(220, 220, 220, 1);
        margin: 0 20px;
      }

      .category_div {
        display: flex;
        align-items: center;
        height: 180px;
        border-bottom: 1px solid rgba(220, 220, 220, 1);
        width: 100%;
        overflow: hidden;
        img {
          width: 200px;
          height: 115px;
          margin-right: 9px;
        }

        p {
          margin: 0;
          padding: 0;
        }

        .div_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 115px;
          flex: 1;
          overflow: hidden;
        }

        .li_title {
          font-weight: 700;
          font-size: 24px;
          color: #333333;
          margin-bottom: 5px;
        }

        .li_info {
          font-size: 16px;
          color: #666666;
          text-align: justify;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .li_time {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }

    }
  }
}

.pagination_con {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
